var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-edit-page"},[_c('sub-header-section',{attrs:{"pageTitle":_vm.$tc('PaymentPage.EditPage.pageTitle')}}),_c('payment-edit-pane')],1)}
var staticRenderFns = []

export { render, staticRenderFns }